import React from "react";
import { Button, Typography } from "@mui/material";
import {
  StyledDialogActions,
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
} from "../../../assets/css/styledComponent";

const DeleteConfirmationStyledDialog = ({
  open,
  staffName,
  handleClose,
  handleDelete,
}) => (
  <StyledDialog open={open} onClose={handleClose}>
    <StyledDialogTitle>Confirmation</StyledDialogTitle>
    <StyledDialogContent>
      <Typography>
        Are you sure you want to delete staff member {staffName}?
      </Typography>
    </StyledDialogContent>
    <StyledDialogActions>
      <Button onClick={handleClose} color="primary">
        Cancel
      </Button>
      <Button onClick={handleDelete} color="secondary">
        Delete
      </Button>
    </StyledDialogActions>
  </StyledDialog>
);

export default DeleteConfirmationStyledDialog;
